import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'
import env from '@/env'

Vue.use(VueI18n)

export default new VueI18n({
  locale: env.locale(),
  fallbackLocale: env.fallbackLocale(),
  messages,
})
